import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/dividend-discount-model-calculator',
  component: () => import('../../routes/DividendDiscountModelCalculator.svelte'),
  card: {
    id: 'dividend-discount-model-calculator',
    title: 'Dividend Discount Model (DDM)',
    description: 'Calculate the intrinsic value of a dividend-paying stock using the Gordon Growth Model.',
    icon: 'trending_up',
    iconBgClass: 'bg-emerald-50',
    iconTextClass: 'text-emerald-600',
    href: '/dividend-discount-model-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Dividend Discount Model (DDM) Calculator – Gordon Growth Model',
    description: 'Free Dividend Discount Model calculator using the Gordon Growth Model (V₀ = D₁ / (r − g)) to find the intrinsic value of dividend-paying stocks.',
  },
};

export default meta;
